export const authRoutes = {
	me: '/me/',
	meChangePassword: '/me/change_password/'
} as const
